const DESKTOP_MAX_WIDTH = 530
export const __wrapper = ({
	customStyles: { width, margin, ...customStyle },
}) => ({
	width: width || DESKTOP_MAX_WIDTH,
	margin: margin || '0 auto',

	...customStyle,
})
